import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable,  of as observableOf , interval, Subscription } from 'rxjs';

import { ITickets } from 'src/app/models/tickets.interface';

import { startWith, switchMap, catchError, map, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {IPlayremainders} from '../../models/playremainders.interface';
import {INext} from '../../models/next.interface';
import {MonitoringService} from '../utility/monitoring/monitoring.service';
import {NotTranslatedServiceService} from '../translate/not-translated-service.service';
import {Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';
import {UrlControllerService} from '../url-controller.service';
import {RaceService} from '../http/race/race.service';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';

@Injectable({
  providedIn: 'root'
})
export class TicketsService extends UrlControllerService{

  private _ticketSelected: string;

  private _session: string;

  private _ticketDetail: any;


  get ticketSelected(): string {
    return this._ticketSelected;
  }

  set ticketSelected(ticketSelected: string) {
    this._ticketSelected = ticketSelected;
  }

  set sesssionSelected(sessionSelected: string) {
    this._session = sessionSelected;
  }

  get sesssionSelected(): string {
    return this._session;
  }

  get ticketDetail(): any {
    return this._ticketDetail;
  }

  set ticketDetail(ticketDetail: any) {
    this._ticketDetail = ticketDetail;
  }



  constructor(private http: HttpClient, private monitoringService: MonitoringService,  private nts: NotTranslatedServiceService, public _store: Store<IAppState>, public raceService: RaceService) {
    super(_store);
  }


  retriveDetail(): Observable<any>  {
    return this.getTicketDetail(this._ticketSelected, this._session)
        .pipe(
            map(data => {
              return data;
            }),
            catchError(() => {

              return observableOf({});
            })
        );
  }


  getTickets(dateFrom: string, dateTo: string, status: string, session: string): Observable<ITickets> {
    const requestUrl =
        `${this.apiUrlSelected}rest/online/tickets/` +
        `${session}/ALL/0/${dateFrom}/${dateTo}/${status}/9999`;

    return this.http.get<ITickets>(requestUrl);
  }

  private getTicketDetail(idBiglietto: string, session: string): Observable<any> {
    const requestUrl =
        `${this.apiUrlSelected}rest/online/ticket/` +
        `${idBiglietto}`; // + '/' + `${session}`;

    return this.http.get<any>(requestUrl);
  }

  getPlayReminders(session: string, race: number, events: boolean) {
    if (session.search(',') !== -1) {
      this.nts.notTranslated(session);
    }
    const requestUrl =
        `${this.apiUrlSelected}rest/online/playreminders/` +
        `${session}` + '/' +
        `${race}`;

    return this.http.get<IPlayremainders>(requestUrl).pipe(
        map((x) => {
          return { playload: x, events: events};
        }),
        catchError(
            this.monitoringService.handleError<IPlayremainders>('getPlayremainders', { giocata: [] })
        )
    );
  }
  
  getCombinationSistemi(ticket, sistema): Observable<any> {
    return this.http.get( `${this.apiUrlSelected}rest/online/ticket/system/` + ticket.header.id_biglietto + '/' + sistema).pipe(
      map((data: any) => {
        if (data) {
          data.scommesse = [];
          data.comb.forEach((ele: any, index) => {
            data.scommesse[index] = [];
            ele.dett.forEach((sel) => {
              data.scommesse[index].push(ticket.scommesse.filter((e) => e.id === sel.sel)[0]);
            });
            data.comb[index].scommesse = data.scommesse[index];
          });
          delete data.scommesse;
          data.comb = orderBy(data.comb, 'vincita', 'desc');
          return data.comb;
        }
      }),
      catchError(() => {
          return observableOf({});
      })
    );
  }



}
